var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAwesomeBusinessTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.131,
    height: 16.105,
    viewBox: "0 0 20.131 16.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-business-time",
    "data-name": "Icon awesome-business-time",
    d: "M15.6,7.046a4.53,4.53,0,1,0,4.53,4.53A4.527,4.527,0,0,0,15.6,7.046Zm2.013,4.727a.306.306,0,0,1-.305.305H15.4a.306.306,0,0,1-.305-.305V9.365a.306.306,0,0,1,.305-.305h.4a.306.306,0,0,1,.305.305v1.707h1.2a.306.306,0,0,1,.305.305ZM15.6,6.039c.17,0,.337.01.5.025V4.53A1.548,1.548,0,0,0,14.6,3.02H12.079V1.51A1.548,1.548,0,0,0,10.569,0H5.536a1.548,1.548,0,0,0-1.51,1.51V3.02H1.51A1.548,1.548,0,0,0,0,4.53V7.046H12.429A5.5,5.5,0,0,1,15.6,6.039ZM10.066,3.02H6.039V2.013h4.026Zm.215,7.046H6.543a.5.5,0,0,1-.5-.5V8.053H0v4.53a1.548,1.548,0,0,0,1.51,1.51h9.167a5.462,5.462,0,0,1-.4-4.026Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeBusinessTime);
export default __webpack_public_path__ + "static/media/Icon_awesome-business-time.bf0fc94dbb68408723c3b5ac16d1ab43.svg";
export { ForwardRef as ReactComponent };